import {
  setFilters,
  useRatesPricingContext,
} from '@/app/providers/rates-pricing';
import { Select } from '@/components/input';

export type FilterItem = {
  id: string;
  name: string;
  disabled: boolean;
};

export const Filters = () => {
  const {
    state: { filters, options },
    dispatch,
  } = useRatesPricingContext();

  return (
    <div className="container">
      <div className="grid grid-cols-1 max-md:gap-y-4 md:grid-cols-4">
        <div className="col-span-1">
          <Select
            label="For my:"
            name="for-my"
            options={options.customerType}
            onChange={(val) => dispatch(setFilters({ customerType: val }))}
            selectedOption={filters.customerType}
          />
        </div>
        <div className="col-span-1">
          <Select
            label="Fuel type:"
            name="fuel-type"
            options={options.energyType}
            onChange={(val) => dispatch(setFilters({ energyType: val }))}
            selectedOption={filters.energyType}
          />
        </div>
        <div className="col-span-1">
          <Select
            label="Tariff type:"
            name="tariff-type"
            options={options.tariffType}
            onChange={(val) => dispatch(setFilters({ tariffType: val }))}
            selectedOption={filters.tariffType}
          />
        </div>
        <div className="col-span-1">
          <Select
            label="Energy plans:"
            name="energy-plans"
            options={options.planName}
            onChange={(val) => dispatch(setFilters({ planName: val }))}
            selectedOption={filters.planName}
          />
        </div>
      </div>
    </div>
  );
};
